export var MuiSvgIcon = {
  styleOverrides: {
    fontSizeSmall: {
      width: '.9rem',
      height: '.9rem'
    }
  }
};
//# sourceMappingURL=MuiSvgIcon.js.map